import React, { useState } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import { getBlogCategoriesWithPagination, deleteBlogCategory } from "adminApi/BlogApi/BlogCategory";
import DataTable from "Common/DataTable/DataTable";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import { generateDisplayFields } from "utils/fieldMapper";
import fields from "../../../json/BlogCategoryFields.json";
import { FilterStatus } from "utils/FilterStatus";

const BlogCategoryTable = () => {
    const [search, setSearch] = useState("");
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const debouncedSearch = useDebouncedValue(search, 500);
    const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
    const sizeOptions = [10, 20, 50, 100];
    const { tabledata } = fields;

    // Uses the paginated API — same pattern as every other list table in the project
    const { data, meta, loading, error, refetch } = usePaginatedFetch(getBlogCategoriesWithPagination, {
        page,
        limit,
        search: debouncedSearch,
        title: "Blog Categories",
    });

    const displayFields = generateDisplayFields(tabledata);
    const filteredData = FilterStatus(data);

    const { formattedData, columns } = useTableConfig({
        data: filteredData,
        page,
        limit,
        canShowAction,
        refetch,
        IsDelete: true,
        config: {
            entityName: "Blog Category",
            editUrl: "edit-blog-category",
            idKey: "id",
            deleteApi: deleteBlogCategory,
            displayFields,
        },
    });

    const handleSearch = (val, resetPage = null) => {
        setSearch(val);
        if (resetPage !== null) setPage(resetPage);
    };

    return (
        <DataTable
            columns={columns}
            data={formattedData}
            options={{
                loading,
                error,
                sortableColumns: displayFields.map((f) => f.accessor),
                copy: true,
                csv: true,
                pdf: true,
                print: true,
            }}
            Search={{
                search: true,
                SearchInputValue: search,
                handleSearch,
            }}
            Entries={{
                Entries: true,
                limit,
                onLimitChange: (newLimit) => { setLimit(newLimit); setPage(1); },
                options: sizeOptions,
            }}
            pagination={{
                isActive: true,
                meta,
                onPageChange: (p) => setPage(p),
            }}
        />
    );
};

export default BlogCategoryTable;
